import { memo } from 'react';

import { Button } from '@air/primitive-button';

export const SSOInProgress = memo(() => {
  return (
    <>
      <h1 className="mx-auto mb-5 max-w-xl text-center text-32 md:mb-7">Securely signing you in...</h1>
      <p className="mx-auto mb-5 max-w-md text-center text-16">
        We’re verifying your identity. You’ll be redirected to your workspace within 30 seconds.
      </p>
      <Button isLoading disabled size="large">
        Logging in...
      </Button>
    </>
  );
});

SSOInProgress.displayName = 'SSOInProgress';
